import { render, staticRenderFns } from "./ActivityReport.vue?vue&type=template&id=0c6a51fa&lang=pug"
import script from "./ActivityReport.vue?vue&type=script&lang=js"
export * from "./ActivityReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DateTimeInput: require('/home/docker/code/frontend/components/DateTimeInput.vue').default,Icon: require('/home/docker/code/frontend/components/Icon.vue').default,ActivityContext: require('/home/docker/code/frontend/components/ActivityContext.vue').default,Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default})
